import React from 'react';

// tslint:disable max-line-length
const CStartGiftTranscriptMunch: React.FC = () => (
  <>
    <h5>Introduction</h5>
    <p>Hey. Today, you’re going make a gift for someone special. They might be next to you right now. They might be on the other side of the world. Close your eyes and try to get a picture of them in your head.</p>
  </>
);

export {
  CStartGiftTranscriptMunch,
};
